module.exports = "<div class=\"js-handler c-video-player__track u-fit-h u-relative\"></div>\n";
